import { render, staticRenderFns } from "./ExternalTickets.vue?vue&type=template&id=447e3c47&"
import script from "./ExternalTickets.vue?vue&type=script&lang=js&"
export * from "./ExternalTickets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports